import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import { HairLibPublicModel, HairstyleBloggerLabelModel } from '@/types/hairstyle';
import Image from 'next/image';
import { fetchHairstyleLibPublicData } from '@/lib/service';
import { message, Spin } from 'antd';
import { HairstyleMainItemModel } from '@/types/home';
import { imgUrl } from '@/shared/utils';
import DownloadAndReportContent from '@/components/Common/DownloadAndReportContent';
import { useRouter } from 'next/router';
import { useUserProvider } from '@/context/UserProvider';
import UploadImageContent from '@/components/HairChangeContent/UploadImageContent';
import classNames from 'classnames';
import { useConfigProvider } from '@/context/ConfigProvider';
import LabelFilterArea from '@/components/Common/LabelFilterArea';
import { mainLabelMap } from '@/common/mainLabel';
import { getDataByPathId } from '@/common/LandingDataContent';
import _ from 'lodash';
const MainContent = ({ data, id }: { data?: any; id?: string }) => {
  const router = useRouter();
  const { isLogin, onChangedLoginView, onOpenLoginModal } = useUserProvider();
  const { isMobile } = useConfigProvider();
  const [libId, setLibId] = useState<any>(null);

  const [lebelList, setLebelList] = useState<HairstyleBloggerLabelModel[]>(data?.lebelList ?? []);
  const [dataList, setDataList] = useState<HairLibPublicModel[]>(data?.dataList ?? []);

  const [mainLoading, setMainLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(1);

  const [showMoreList, setShowMoreList] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [currentPageNo, setCurrentPageNo] = useState(1);

  useEffect(() => {
    if (currentIndex > 3 && hasMore) {
      setCurrentPageNo(currentPageNo + 1);
    }
  }, [currentIndex]);

  const getDataList = () => {
    if (currentPageNo === 1) {
      return dataList?.slice(0, currentIndex * 10);
    } else {
      return dataList;
    }
  };

  const genderList = useMemo(() => {
    let tempVal = data?.pathParam?.gender;
    if (tempVal !== 'men' && tempVal !== 'women') {
      tempVal = 'all';
    }
    return [
      {
        lebal: 'All',
        value: 'all',
        select: tempVal === 'all'
      },
      {
        lebal: 'Women',
        value: 'women',
        select: tempVal === 'women'
      },
      {
        lebal: 'Men',
        value: 'men',
        select: tempVal === 'men'
      }
    ];
  }, [data?.pathParam]);

  useEffect(() => {
    setLebelList(data?.lebelList ?? []);
    setDataList(data?.dataList ?? []);
  }, [data]);

  function getRandomColor(): string {
    // 生成随机的明亮颜色，避免深色
    const getRandomBrightValue = () => {
      // 限制在128-255之间以确保颜色明亮
      return Math.floor(Math.random() * 128) + 128;
    };

    // 生成RGB三个通道的值，确保都在明亮范围内
    const red = getRandomBrightValue();
    const green = getRandomBrightValue();
    const blue = getRandomBrightValue();

    // 转换为16进制颜色代码
    return `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue
      .toString(16)
      .padStart(2, '0')}`;
  }

  useEffect(() => {
    if (currentPageNo > 1) {
      fetchHairstyleData(currentPageNo);
    }
  }, [currentPageNo]);
  // 判断pc label长度
  useEffect(() => {
    if (!isMobile) {
      if (data?.lebelList?.length < 10) {
        setShowMore(true);
      }
    } else {
      setShowMore(false);
    }
  }, [isMobile, data?.lebelList]);

  const fetchHairstyleData = async (page_no: number) => {
    setMainLoading(true);
    try {
      const res = await fetchHairstyleLibPublicData(
        {
          page_no: page_no,
          page_size: 30,
          gender: data?.pathParam?.gender,
          label: data?.pathParam?.label === 'all' ? '' : data?.pathParam?.label
        },
        mainLabelMap.get(data?.pathParam?.pathId)
      );
      if (res?.code === 0) {
        setHasMore(res?.has_next);
        setShowMoreList(res?.has_next);
        setDataList([...dataList, ...res?.data]);
        setMainLoading(false);
      } else {
        message.error(res?.message);
        setMainLoading(false);
      }
    } catch {
      setMainLoading(false);
      message.error('error');
    }
  };

  const getItem = (item: HairstyleMainItemModel) => {
    return (
      <div key={item?.lib_id} className={styles.hairstyleCard}>
        <div
          className={styles.imageContainer}
          onClick={() => {
            if (isMobile) {
              if (isLogin) {
                setLibId(item?.lib_id);
              } else {
                onChangedLoginView(true);
                onOpenLoginModal(true);
              }
            }
          }}
        >
          <img src={imgUrl(item?.image_url)} alt={item?.image_alt} loading="lazy" />
          <div className={styles.editBadge}>
            <Image
              src={imgUrl(item?.blogger_avatar)}
              alt={''}
              width={24}
              height={24}
              style={{ width: '24px', height: '24px', borderRadius: '12px' }}
            />
            <span>{item?.blogger_name}</span>
          </div>
          <div className={styles.topRightContainer}>
            <DownloadAndReportContent imgUrlStr={item?.image_url} libId={item?.lib_id} />
          </div>

          <div className={styles.tryOnContainer}>
            <span
              onClick={() => {
                if (isLogin) {
                  setLibId(item?.lib_id);
                } else {
                  onChangedLoginView(true);
                  onOpenLoginModal(true);
                }
              }}
            >
              {'Try on'}
            </span>
          </div>
        </div>
        <div className={styles.tags}>
          {item?.labels?.map((tag, tagIndex) => {
            const tempColor = getRandomColor();
            return (
              <span
                key={tagIndex}
                className={styles.tag}
                style={{ color: tempColor, border: `1px solid ${tempColor}` }}
                onClick={() => {
                  router.push(`/hairstyle?label=${tag}`);
                }}
              >
                {tag}
              </span>
            );
          })}
        </div>
      </div>
    );
  };

  const onChangePath = (gender: string, label?: string) => {
    if (gender === 'all') {
      if (label?.length > 0 && label?.toLocaleLowerCase() !== 'all') {
        router.replace(`/${data?.pathParam?.pathId}/${label?.toLocaleLowerCase()}`);
      } else {
        router.replace(`/${data?.pathParam?.pathId}`);
      }
    } else {
      if (label?.length > 0 && label?.toLocaleLowerCase() !== 'all') {
        router.replace(`/${data?.pathParam?.pathId}/${gender?.toLocaleLowerCase()}-${label?.toLocaleLowerCase()}`);
      } else {
        router.replace(`/${data?.pathParam?.pathId}/${gender?.toLocaleLowerCase()}`);
      }
    }
  };
  const pathId = data?.pathParam?.pathId;
  const label = data?.pathParam?.label;
  const labelShow = _.upperFirst(label);
  const labelContent = getDataByPathId(pathId || '');

  return (
    <>
      <Spin spinning={mainLoading}>
        <div className={styles.content}>
          <div className={styles.topBtns} id={id}>
            {genderList?.map((item) => {
              const styleStr = item?.select ? `${styles.active1}` : `${styles.active2}`;
              return (
                <span
                  key={item.value}
                  className={styleStr}
                  onClick={() => {
                    onChangePath(item?.value, data?.pathParam?.label);
                  }}
                >
                  {item?.lebal}
                </span>
              );
            })}
          </div>

          <div className={styles.labelGroundContainer}>
            <LabelFilterArea
              type="image"
              labels={lebelList}
              selectedItem={data?.pathParam?.label?.toLocaleLowerCase()}
              showMoreButton={false}
              maxDisplayCount={lebelList?.length}
              layoutMode={isMobile ? 'scroll' : 'wrap'}
              className={classNames(showMore && styles.moreLabelsList)}
              onItemClick={(item) => {
                onChangePath(data?.pathParam?.gender, item);
              }}
            />
          </div>
          <div className={styles.summaryContainer}>
            <div className={styles.summaryTitle}>
              {(() => {
                if (label === 'all') {
                  return labelContent.main_tip.all;
                }
                const title = labelContent.main_tip.other;
                const parts = title.split('***');
                return (
                  <h2 className={styles.summaryTitle}>
                    <span>{data?.total + ' '}</span>
                    {parts[0]}
                    <span>{labelShow}</span>
                    {parts[1]}
                  </h2>
                );
              })()}
            </div>
            <div className={styles.summaryDesc}>
              Pick any hairstyle below and see how it looks on you instantly with our AI-powered hairstyle simulator!
            </div>
          </div>
          {/* 发型列表 */}
          {dataList?.length > 0 ? (
            <div className={styles.hairstyleGrid}>{getDataList()?.map((item) => getItem(item))}</div>
          ) : (
            <div
              style={{
                display: 'flex',
                gap: 20,
                justifyContent: 'center',
                alignItems: 'center',
                padding: '120px 0'
              }}
            >
              <div>
                <Image src="/images/hairstyle/empty-data.webp" width={80} height={80} alt="empty data" />
              </div>
              <div>
                <div style={{ fontSize: 20, lineHeight: '20px', fontWeight: 500, marginBottom: 20 }}>
                  No data available in this category.
                </div>
                <div style={{ fontSize: 20, lineHeight: '20px', color: '#FFFFFF99' }}>
                  Please explore other categories or try again later.
                </div>
              </div>
            </div>
          )}

          {showMoreList && (
            <div className={styles.moreButtonContainer}>
              <button
                className={styles.moreButton}
                onClick={() => {
                  setCurrentIndex(currentIndex + 1);
                }}
              >
                more <span className={styles.arrowDown}>▼</span>
              </button>
            </div>
          )}
        </div>
      </Spin>

      <UploadImageContent openId={libId} handleClose={() => setLibId(null)} />
    </>
  );
};

export default MainContent;
